import React from "react";
import { Target } from "lucide-react";
import Reveal from "../common/Reveal";

const Mission = () => {
  return (
    <section className="py-16">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">
        <Reveal>
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-primary-50">
            <Target className="h-7 w-7 text-primary-700" strokeWidth={1.75} />
          </div>
          <span className="mt-6 block text-sm font-semibold uppercase tracking-wide text-accent-600">
            Our Mission
          </span>
          <h2 className="mt-3 break-keep text-3xl font-bold leading-snug text-primary-900 sm:text-4xl">
            흩어진 제조 데이터를 연결해,
            <br />
            현장이 스스로 답을 찾게 합니다
          </h2>
          <p className="mx-auto mt-6 max-w-2xl break-keep text-base leading-relaxed text-gray-600">
            MTST는 생산·품질·설비에서 발생하는 데이터를 표준화하고 분석하여
            제조 현장의 의사결정을 데이터 위에 세웁니다. 복잡한 문제를
            가장 단순한 솔루션으로 풀어내는 것, 그것이 우리가 존재하는
            이유입니다.
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default Mission;
